module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.28a28ef3.svg";